import React, { useEffect, useState } from "react";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { buildLandingHtml, DEFAULT_LANDING, AI_PLACEHOLDER } from "@/pages/tmc/landingTemplate";

export default function HomeLanding() {
  const [html, setHtml] = useState(null);
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/api/landing/home`)
      .then((r) => { const d = r.data || {}; const isAi = d.page_type === "ai" || d.mode === "ai"; setHtml(isAi ? (d.ai_html || AI_PLACEHOLDER) : buildLandingHtml(d)); })
      .catch(() => setHtml(buildLandingHtml(DEFAULT_LANDING)));
  }, []);
  if (!html)
    return (
      <div style={{ minHeight: "100vh", background: "#08060f", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Loader2 className="w-8 h-8 animate-spin" style={{ color: "#a855f7" }} />
      </div>
    );
  return <iframe title="The Money Club" srcDoc={html} data-testid="home-landing-frame"
    style={{ border: 0, width: "100vw", height: "100vh", display: "block" }} />;
}
